import React, { useState } from 'react';
import CommonModal from '../modalLayout/CommonModal';
import { useGetUnassignedSurveysQuery, useAssignSurveyMutation } from '../../../app/surveyApi/surveyApi';
import { Spinner, Form } from 'react-bootstrap';
import Button from '../buttons/button';
import { showToast } from '../../../helpers/Utils';
import './modalContent.css';

const AssignServeyModal = ({ show, handleClose, setShow, userId,leadId }) => {
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [assigningSurveyId, setAssigningSurveyId] = useState(null); // 👈 new local state

  const [assignSurvey] = useAssignSurveyMutation();

  // Debounce search input
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timeout);
  }, [search]);

  const { data: surveyList, isLoading: isSurveyLoading } = useGetUnassignedSurveysQuery({
    userId: userId,
    page: 1,
    limit: 10,
    search: debouncedSearch,
    leadId
  },
    {
      skip: !userId && !leadId
    });

  const handleAssign = async (surveyId) => {
    setAssigningSurveyId(surveyId);
    try {
      await assignSurvey({ userId, surveyId ,leadId}).unwrap();
      showToast("Survey assigned successfully", "success");

    } catch (err) {
      console.log(err, "err");

      showToast(err?.data?.message || "Failed to assign survey", "error");
    } finally {
      setAssigningSurveyId(null);
    }
  };

  return (
    <CommonModal show={show} setShow={setShow} title="Assign Survey">
      <Form.Control
        type="search"
        placeholder="Search surveys..."
        className="mb-3"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {isSurveyLoading ? (
        <div className="text-center py-3">
          <Spinner animation="border" size="sm" /> Loading...
        </div>
      ) : surveyList?.data?.data?.length > 0 ? (
        <ul className="p-0 d-flex flex-xl-column gap-3">
          {surveyList.data.data.map((servey) => (
            <li key={servey._id} className="d-flex justify-content-between survey-assign align-items-center">
              <span className="flex-grow-1">{servey?.title}</span>
              <Button
                label={assigningSurveyId === servey._id ? "Assigning..." : "Assign Survey"}
                size="xs"
                disabled={assigningSurveyId === servey._id}
                onClick={() => handleAssign(servey._id)}
              />
            </li>
          ))}
        </ul>
      ) : (
        <div className="text-center text-muted py-3">No surveys found.</div>
      )}
    </CommonModal>
  );
};

export default AssignServeyModal;
